import React, { useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { TextArea, Popup, Tooltip } from '_atoms';
import { Form } from 'antd';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { RULES } from '_templates/CreateOpening/constants';
import { TOOLTIP_TXT } from 'constants/constants';
import { BUTTON_TEXT } from 'constants/text';
import { ReactComponent as Info } from 'dist/icons/info.svg';
import type { Opening } from 'store/reducers/jobReducer';
import './style.scss';

interface PopupCloseDeclineOpeningProps {
  open: boolean;
  onClose: () => void;
  confirm: (comment: string, opening: Opening) => void;
  close?: boolean;
  opening?: Opening;
  jobName: string;
}

export const PopupCloseDeclineOpening: React.FC<PopupCloseDeclineOpeningProps> = ({
  open,
  onClose,
  confirm,
  close,
  opening = {} as Opening,
  jobName,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    form.resetFields();
  }, [open, form]);

  return (
    <Popup
      open={open}
      title={
        close
          ? t('translation:popup_close_decline_opening.title_close_opening')
          : t('translation:popup_close_decline_opening.title_decline_opening')
      }
      cancelButtonProps={{ onClick: onClose, children: BUTTON_TEXT.CANCEL }}
      okButtonProps={{
        form: 'form-close-opening',
        htmlType: 'submit',
        children: close
          ? t('translation:popup_close_decline_opening.button_close_opening')
          : t('translation:popup_close_decline_opening.button_decline'),
      }}
      className="mobile-full-size"
    >
      <div className="popup-close-opening">
        <Typography.Text className="popup-close-opening__title" weight={TYPOGRAPHY_WEIGHT.BOLD}>
          {`${opening.custom_level || opening.level} ${jobName}`}
        </Typography.Text>
        <Typography.Caption className="popup-close-opening__subtitle">
          {t('translation:popup_close_decline_opening.text_expected_on', {
            date: moment(opening.expected).format('MMM DD, YYYY'),
          } as Record<string, unknown>)}
        </Typography.Caption>
        <Form
          id="form-close-opening"
          form={form}
          onFinish={({ comment }) => confirm(comment, opening)}
          validateTrigger="onSubmit"
        >
          <TextArea
            label={
              close ? (
                <>
                  {t('translation:popup_close_decline_opening.label_comment')}
                  <Tooltip label={TOOLTIP_TXT.MIN_10_CHARS}>
                    <Info />
                  </Tooltip>
                </>
              ) : (
                t('translation:popup_close_decline_opening.label_decline_reason')
              )
            }
            placeholder={
              close
                ? t('translation:popup_close_decline_opening.ph_enter_comment')
                : t('translation:popup_close_decline_opening.ph_enter_reason')
            }
            itemProps={{ name: 'comment', rules: close ? RULES.RICHAREA_MIN_LENGTH(10) : RULES.REQUIRED }}
          />
        </Form>
      </div>
    </Popup>
  );
};
